import React from 'react';
import ReactJson from 'react-json-view';

const containerStyle = { maxHeight: 480, overflow: 'auto' };
const rjvStyle = { minHeight: 120, maxHeight: 680 };

/**
 * Collapsible JSON tree using react-json-view (same family as Auction Snapshot).
 * @param {object|array|string|number|boolean|null} src - Parsed JSON value (use JSON.parse on strings before passing, or pass objects)
 */
export default function JsonTreeView({ src }) {
  return (
    <div data-testid="json-tree-view" style={containerStyle}>
      <ReactJson src={src} name={false} displayDataTypes={false} displayArrayKey={false} style={rjvStyle} />
    </div>
  );
}
